import styled from "styled-components";

export const MenuOverViewWrap = styled.div`
    background-color: ${({theme}) => theme?.light?.primary50};
    border-radius: 15px;
    padding: 20px;
    margin-bottom: 30px;
    .btn {
        display: flex;
        justify-content: center;
        width: 150px;
        button {
            background: ${({theme}) => theme?.light?.primary};
            padding: 13px 20px;
            border-radius: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 5px;
            color: white;
            font-size: 16px;
            line-height: 20px;
            width: 100%;
        }
        .item {
            font-size: 14px;
            line-height: 18px;
            display: flex;
            gap: 10px;
            border-bottom: 1px solid #e7e7e7;
            &:nth-last-child(1) {
                border-bottom: none;
            }
        }
        .disabled {
            pointer-events: none;
            opacity: 0.5;
        }
    }
    .text-wrap {
        @media (min-width: 768px) {
            display: flex;
            justify-content: space-between;
            align-items: start;
        }
        .left-content {
            margin-bottom: 20px;
            @media (min-width: 992px) {
                margin-bottom: 0;
            }
            .dropdown-btn {
                button {
                    font-size: 20px;
                    line-height: 24px;
                    display: flex;
                    align-items: center;
                    gap: 5px;
                }
                .item {
                    font-size: 14px;
                    line-height: 18px;
                }
                .szh-menu {
                    left: -16px !important;
                }
            }
            .mainDropdown {
                button {
                    font-size: 20px;
                    line-height: 24px;
                    display: flex;
                    align-items: center;
                }
            }
            .inner {
                font-size: 16px;
                line-height: 20px;
                font-weight: 300;
                @media (min-width: 768px) {
                    font-size: 18px;
                    line-height: 22px;
                }
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                gap: 20px;
                margin-bottom: 20px;
                @media (min-width: 575px) {
                    align-items: center;
                    flex-direction: row;
                }
                p {
                    margin: 0;
                }
                button {
                    background-color: transparent;
                    border: 1px solid var(--black);
                    color: var(--black);
                }
            }
        }
        .right-content {
            button {
                svg {
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
    .dropdownWrap {
        position: relative;
        width: 100%;
        /* max-width: 70px; */
        .dropdownBtn {
            cursor: pointer;
            display: flex;
            gap: 5px;
            align-items: center;
            justify-content: start;
            margin-bottom: 10px;
            svg {
                width: 16px;
                height: 16px;
            }
            .heading {
                font-size: 20px;
                line-height: 24px;
                font-weight: 400;
            }
        }
    }
`;
export const DropDown = styled.div`
    position: absolute;
    top: 30px;
    left: 0;
    padding: 10px 15px;
    background-color: var(--white);
    width: 100%;
    max-width: 180px;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(30px);
    transition: 0.4s;
    z-index: 2;
    &.active {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
    }
    .col {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 8px 0 0;
        cursor: pointer;
        border-bottom: 1px solid #e7e7e7;
        &:nth-last-child(1) {
            border-bottom: none;
        }
    }
`;
